import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { MASTERS_MANAGEMENT } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

interface SystemConfigurationState {
  systemConfigurationList: any
  editObj: any
}

const initialState: SystemConfigurationState = {
  systemConfigurationList: [],
  editObj: {},
}

const systemConfigurationSlice = createSlice({
  name: 'systemConfiguration',
  initialState,
  reducers: {
    setSystemConfigurationList: (state, action) => {
      state.systemConfigurationList = action?.payload ? action.payload : null
    },
    setEditObj: (state, action) => {
      state.editObj = {
        ...state.editObj,
        ...action?.payload,
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clearSystemConfigurationStore: (state: any, _action) => {
      state.systemConfigurationList = []
      state.editObj = {}
    },
  },
})

export const { setSystemConfigurationList, setEditObj, clearSystemConfigurationStore } =
  systemConfigurationSlice.actions
const systemConfigurationSelector = (state: any) => state.systemConfiguration

export const selectSystemConfigurationList = createSelector(
  systemConfigurationSelector,
  (state) => state.systemConfigurationList,
)
export const selectEditObj = createSelector(systemConfigurationSelector, (state) => state.editObj)

export const getMasterByKey = createAsyncThunk(
  'systemConfiguration/getMasterByKey',
  async (data: any) => {
    const requestedData: any = MASTERS_MANAGEMENT.SYSTEM_CONFIGURATION_CRUD.LIST(data)
    const result = await mainApiService(requestedData)
    return result
  },
)

export default systemConfigurationSlice
